// The full Teleos overview page (EXP 04): what it is, why Paramount uses it,
// how to get access, four actions, and related guides, training, known issues
// and upcoming changes. Missing routes are labelled as placeholders.

import { esc } from '../api';
import type content from '../content/sample-content.json';
import { formatWhen } from '../notifications';
import type { UpcomingChange } from './home';

type Content = typeof content;

export function renderTeleos(data: Content, changes: UpcomingChange[]): string {
  const t = data.teleos;
  const guides = data.guides.filter((g) => t.related.guides.includes(g.id));
  const training = data.training.filter((x) => t.related.training.includes(x.id));
  const teleosChanges = changes.filter((c) => c.systems.includes(t.related.changesSystem));
  return `
<h1>${esc(t.title)}</h1>
<section aria-labelledby="t-what"><h2 id="t-what">What it is</h2><p>${esc(t.overview)}</p></section>
<section aria-labelledby="t-why"><h2 id="t-why">Why Paramount uses it</h2><p>${esc(t.why)}</p></section>
<section aria-labelledby="t-access"><h2 id="t-access">How to get access</h2><ol>${t.access.map((s) => `<li>${esc(s)}</li>`).join('')}</ol></section>
<section aria-labelledby="t-actions">
  <h2 id="t-actions">Actions</h2>
  <ul class="actions">${t.actions
    .map((a) =>
      a.placeholder || !a.url
        ? `<li data-action-id="${esc(a.id)}"><span class="placeholder" title="Demonstration placeholder">${esc(a.label)} (placeholder)</span></li>`
        : `<li data-action-id="${esc(a.id)}"><a class="button" href="${esc(a.url)}">${esc(a.label)}</a></li>`,
    )
    .join('')}</ul>
</section>
<section aria-labelledby="t-related">
  <h2 id="t-related">Related</h2>
  <h3>Guides</h3><ul>${guides.map((g) => `<li><a href="#/guides/${esc(g.id)}">${esc(g.title)}</a></li>`).join('')}</ul>
  <h3>Training</h3><ul>${training
    .map((x) => `<li>${esc(x.title)}${x.placeholder ? ' <span class="placeholder">placeholder</span>' : ''}</li>`)
    .join('')}</ul>
  <h3>Known issues</h3><ul>${t.related.knownIssues.map((k) => `<li>${esc(k)}</li>`).join('')}</ul>
  <h3>Upcoming changes</h3>${
    teleosChanges.length
      ? `<ul>${teleosChanges
          .map((c) => `<li><a href="#/calendar/${esc(c.id)}">${esc(c.title)}</a> <span class="muted">${esc(formatWhen(c.scheduledStart, c.timezone))}</span></li>`)
          .join('')}</ul>`
      : '<p class="muted">No upcoming Teleos changes.</p>'
  }
</section>`;
}
